export const environment = {
  production: true,
  LoginUrl: 'http://localhost:43344/api/'
};
